import { OmitStrict } from '../../utility-types';
import { CustomBaseButtonProps } from './__internal__';

export enum ButtonVariant {
  Standard = 'button',
  Small = 'small',
  Light = 'light',
  Primary = 'primary',
  PrimarySmall = 'primary-small',
  PrimaryLight = 'primary-light',
  PrimaryIcon = 'primary-icon', // primary-lightweight icon
  Icon = 'icon', // Lightweight icon
  RoundIcon = 'round-icon',
  LightSmall = 'light-small',
  SmallIcon = 'small-icon', // small lightweight icon
}

export enum ButtonState {
  Normal = 'normal',
  Hover = 'hover',
  Active = 'active',
}

export type ButtonTokens = (props: {
  disabled?: boolean;
  state?: ButtonState;
}) => Partial<{ fg: string; bg: string; bd: string; filter: string; fontFamily: string }>;

export interface ButtonProps extends OmitStrict<CustomBaseButtonProps, 'children' | 'type'> {}
